import axios from 'axios';

export const instance = axios.create({
  headers: {
    'Content-type': 'application/vnd.api+json',
  },
});

export default {
  /**
   * @description GET request.
   * @param {String} url
   * @param {Object} [config]
   * @return {promise}
   */
  get: (url, config = {}) => {
    return instance.get(url, config);
  },

  /** @description POST request.
   * @param {String} url
   * @param {Object} [data]
   * @param {Object} [config]
   * @return {promise}
   */
  post: (url, data = {}, config = {}) => {
    return instance.post(url, data, config);
  },

  /**
   * @description DELETE request.
   * @param {String} url
   * @param {Object} [config]
   * @return {promise}
   */
  delete: (url, config = {}) => {
    return instance.delete(url, config);
  },
};
